import LayerGroup from 'ol/layer/Group'
import ImageWMS from 'ol/source/ImageWMS'
import TileWMS from 'ol/source/TileWMS'
import type BaseLayer from 'ol/layer/Base'
import type Collection from 'ol/Collection'
import type Layer from 'ol/layer/Layer'

import { isGisUrl } from 'common/geoserver'

const loadsFromGisProxy = (layer: Layer): boolean => {
  const source = layer.getSource()
  if (source instanceof TileWMS) return (source.getUrls() ?? []).some(isGisUrl)
  if (source instanceof ImageWMS) return isGisUrl(source.getUrl())
  return false
}

/**
 * Make 3D request the GIS proxy's imagery again, after a lapsed session was
 * renewed. Cesium loads those tiles without going through gisFetch, so tiles
 * that failed with 401 stay blank otherwise. ol-cesium answers a layer's
 * `change` event by re-adding its Cesium layer, which requests every tile
 * again; in 2D the event only redraws.
 */
export const reloadGisImagery = (layers: Collection<BaseLayer>): void => {
  layers.forEach((layer) => {
    if (layer instanceof LayerGroup) {
      reloadGisImagery(layer.getLayers())
    } else if (loadsFromGisProxy(layer as Layer)) {
      layer.changed()
    }
  })
}
